const MAP = {
  "Pending": "bg-amber-100 text-amber-800 border-amber-200",
  "Confirmed": "bg-sky-100 text-sky-800 border-sky-200",
  "Processing": "bg-indigo-100 text-indigo-800 border-indigo-200",
  "Packed": "bg-purple-100 text-purple-800 border-purple-200",
  "Ready": "bg-teal-100 text-teal-800 border-teal-200",
  "Out for delivery": "bg-orange-100 text-orange-800 border-orange-200",
  "Delivered": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Cancelled": "bg-red-100 text-red-800 border-red-200",
  "Returned": "bg-rose-100 text-rose-800 border-rose-200",
  "Refunded": "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200",
};

export default function StatusBadge({ status, testid }) {
  return (
    <span data-testid={testid || "status-badge"} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold border ${MAP[status] || "bg-slate-100 text-slate-700 border-slate-200"}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {status}
    </span>
  );
}
